class ListboxState extends WidgetState {
    startElementIndex: number;
    selection: boolean[];

    constructor() {
        super();
        this.startElementIndex = null;
        this.selection = [];
    }

    /**
     * check if two instances of widgetState are equal
     * @param otherWidgetState
     */
    equals(otherWidgetState) {
        if(this.enabled != null && otherWidgetState.enabled != null) {
            if(this.enabled != otherWidgetState.enabled) return false;
        }

        if(this.selection != null && otherWidgetState.selection != null) {
            if(!arrayEquals(this.selection, otherWidgetState.selection)) return false;
        }

        return true;
    }

   /**
     * Create a copy of this state
     */
    getCopy() {
        var result = new ListboxState();

        result.enabled = this.enabled;
        result.startElementIndex = this.startElementIndex;
        result.selection = this.selection; // TODO: Might need a deep copy as well
        result.copyChildrenStates(this);

        return result;
    }
}
